module.exports = global["$"] = require("-!C:\\Git\\Repo\\ZeitloungeLTS\\node_modules\\expose-loader\\index.js?jQuery!.\\jquery.js");